import { createContext, useContext, useEffect } from "react";
import { useAuthStore } from "../stores/useAuthStore";
import { clearSessionState } from './sessionGuard'

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const kc = window.__keycloak;

  const setAuth = useAuthStore((s) => s.setAuth);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  // ------------------------------------------------------------------
  // Sync Keycloak → Zustand auth store
  // ------------------------------------------------------------------
  useEffect(() => {
    if (!kc) return;

    if (kc.token) {
      setAuth({
        token: kc.token,
        user: {
          id: kc.tokenParsed?.sub,
          username: kc.tokenParsed?.preferred_username,
          email: kc.tokenParsed?.email,
          name: kc.tokenParsed?.name,
        },
        roles: kc.tokenParsed?.realm_access?.roles || [],
        orgId: kc.tokenParsed?.org_id || kc.tokenParsed?.orgId || null
      });
    }

    // Keep store in sync on token refresh
    kc.onTokenExpired = async () => {
      try {
        await kc.updateToken(30);

        setAuth({
          token: kc.token,
          user: {
            id: kc.tokenParsed?.sub,
            username: kc.tokenParsed?.preferred_username,
            email: kc.tokenParsed?.email,
            name: kc.tokenParsed?.name,
          },
          roles: kc.tokenParsed?.realm_access?.roles || [],
          orgId: kc.tokenParsed?.org_id || kc.tokenParsed?.orgId || null
        });
      } catch (err) {
        console.error("Keycloak token refresh failed", err);
        clearAuth();
        kc.logout({ redirectUri: window.location.origin });
      }
    };
  }, [kc, setAuth, clearAuth]);

  // ------------------------------------------------------------------
  // Logout
  // ------------------------------------------------------------------
  const logout = () => {
    clearAuth();
    clearSessionState()

    if (!kc) return;

    kc.logout({
      redirectUri: window.location.origin,
    });
  };

  // ------------------------------------------------------------------
  // Context value (unchanged API)
  // ------------------------------------------------------------------
  const value = {
    keycloak: kc,
    token: kc?.token,
    parsedToken: kc?.tokenParsed,
    roles: kc?.tokenParsed?.realm_access?.roles || [],
    username: kc?.tokenParsed?.preferred_username,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);